








































import { Vue, Component } from 'vue-property-decorator';
import { format } from '@/utils/helper';
import { getStorage } from '@/utils/storage';
import LabelInput from '@/components/form/LabelInput.vue';

// 企业的基本信息(非平台)
@Component({
  components: { LabelInput },
})
export default class EnterpriseBaseInfo extends Vue {
  public orgInfo: any = null;
  public labelWidth = '100px';

  public get info() {
    const data = this.orgInfo;
    const userLimit = data?.userLimit || 0;
    const province = data?.province || '';
    const city = data?.city || '';
    const county = data?.county || '';
    const address = data?.address || '';
    return {
      name: data?.fullName || '',
      orgName: data?.name || '',
      orgCode: data?.code || '',
      userLimit: `${userLimit}人`,
      address: [province, city, county, address].filter((item) => item).join(' '),
      createdTime: format(data?.createdTime, true),
      updatedTime: format(data?.updatedTime, true),
    };
  }

  public created() {
    const orgInfo = getStorage('orgInfo');
    this.orgInfo = JSON.parse(orgInfo || 'null');
  }
}
